module.exports = __webpack_public_path__ + "static/media/sample-word-cloud.819556df.svg";